import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { createAuth0, authGuard } from "@auth0/auth0-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import App from "./App.vue";
import LandingPage from "./pages/LandingPage.vue";
import ProfilePage from "./pages/ProfilePage.vue";
import AdminPage from "./pages/AdminPage.vue";
import SnailMailPage from "./pages/SnailMail.vue";
import './registerServiceWorker';

const app = createApp(App);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: LandingPage,
    },
    {
      path: "/profile",
      name: "profile",
      component: ProfilePage,
      beforeEnter: authGuard,
    },
    {
      path: "/admin",
      name: "admin",
      component: AdminPage,
      beforeEnter: authGuard,
    },
    {
      path: "/snail-mail",
      name: "snailMail",
      component: SnailMailPage,
      alias: "/snailmail",
    },
    {
      path: "/:pathMatch(.*)*",
      name: "notFound",
      component: LandingPage,
    },
  ],
});

library.add(fas, far, fab);
app.component("font-awesome-icon", FontAwesomeIcon);

// 1. Install Auth0 plugin first
app.use(
  createAuth0({
    domain: "blything.eu.auth0.com",
    clientId: "jRArVItr8Xs56qikxoamXNhDVWPuG6FI",
    authorizationParams: {
      redirect_uri: window.location.origin,
    },
  })
);

// 2. Install Router SECOND (so authGuard can communicate with Auth0)
app.use(router);

// 3. Mount the app
app.mount("#app");